var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import noop from 'lodash/noop';
import { stringUtils } from 'conversional-utils';
import { ComponentStyles } from 'conversional-theme';
import classNames from "classnames";
import { JourneysSelectors, useAppSelector } from 'conversional-journey';
var defaultProps = {
    size: '1rem',
    onClick: noop,
    rotation: 0
};
var Icon = function (props) {
    // Render same item multiple times, e.g. for star ratings
    if (props.multiple) {
        var icons = [];
        for (var i = 0; i < props.multiple; ++i) {
            icons.push(_createElement(Icon, __assign({}, props, { multiple: 0, key: stringUtils.randomString(5) })));
        }
        return _jsx(React.Fragment, { children: icons });
    }
    var injectedStyles = props.injectedStyles;
    var rotation = props.rotation, size = props.size, hoverColor = props.hoverColor, color = props.color;
    var styleProps = { rotation: rotation, size: size, hoverColor: hoverColor, color: color };
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var className = css(Styles(theme, styleProps).svg, ComponentStyles(injectedStyles));
    return (_jsx("svg", { className: classNames(className, props.className), width: "".concat(props.size), height: "".concat(props.size), viewBox: "".concat(props.icon.viewbox), onClick: props.onClick, children: _jsx("path", { className: css(Styles(theme, styleProps).path), d: props.icon.path }) }));
};
Icon.defaultProps = defaultProps;
var Styles = function (theme, _a) {
    var rotation = _a.rotation, size = _a.size, hoverColor = _a.hoverColor, color = _a.color;
    return StyleSheet.create({
        svg: {
            display: 'inline-block',
            verticalAlign: 'middle',
            transform: "rotate(".concat(rotation, "deg)"),
            height: "".concat(size),
            ':hover > path': {
                fill: hoverColor || color || theme.colors.text
            }
        },
        path: {
            fill: color ? color : theme.colors.text
        }
    });
};
export default Icon;
